import { Directive, ElementRef, HostBinding, HostListener, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { isFirstChange } from '@devwareapps/devware-cap';

@Directive({
    selector: "[dwMagicImage]",
})
export class DwMagicImageDirective implements OnInit, OnChanges {
    @Input() maxWidth: string;
    @Input() maxHeight: string;

    @Input() src: string;

    lastSrc: string;

    
    @HostBinding('style.width')
    width: string;

    @HostBinding('style.height')
    height: string;

    constructor(private el: ElementRef) {
        console.log('dwMagicImageDirective created');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(!isFirstChange(changes)) {
            this.setupImage();
        }
    }

    ngOnInit(): void {
        this.setupImage();
    }

    setupImage() {
        if (!this.src) {
            return;
        }

        if (this.lastSrc && this.src == this.lastSrc) {
            return;
        }

        this.lastSrc = this.src;


        const image = new Image();
        image.src = this.src;

        image.onload = (e: any) => {
            const height = e.path[0].height;
            const width = e.path[0].width;

            if (width > height) {
                this.width = this.maxWidth;
                this.height = null;
            } else {
                this.height = this.maxHeight;
                this.width = null;
            }
        };
    }

}